import { useAccountTypeStructures } from "../../../hooks/useAccountTypeStructures";
import { BANK_ACCOUNT_TYPE } from "./banks.constants";

export function useBankStructures() {
  return useAccountTypeStructures(BANK_ACCOUNT_TYPE);
}
